import { render, staticRenderFns } from "./CamaraDashboardPantalla.vue?vue&type=template&id=6f6542c8&"
import script from "./CamaraDashboardPantalla.vue?vue&type=script&lang=ts&"
export * from "./CamaraDashboardPantalla.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports